import { gql } from "@apollo/client";

export const CREATE_MASTER_DATA_DISTRIBUTION_CENTER = gql`
  mutation CreateMasterDataDistributionCenter(
    $params: CreateMasterDataDistributionCenterInput!
  ) {
    createMasterDataDistributionCenter(params: $params) {
      distributionCenterId
      purchaserId
      dcCode
      dcName
      createdAt
      purchaserName
      purchaserKey
    }
  }
`;

export const UPDATE_MASTER_DATA_DISTRIBUTION_CENTER = gql`
  mutation UpdateMasterDataDistributionCenter(
    $params: UpdateMasterDataDistributionCenterInput!
  ) {
    updateMasterDataDistributionCenter(params: $params) {
      distributionCenterId
      purchaserId
      dcCode
      dcName
      createdAt
      purchaserName
      purchaserKey
    }
  }
`;
